import{defineMessages as e}from"react-intl";const t=e({pressReleaseThumbnailButtonText:{id:"pressPage.viewArticle",defaultMessage:"View Article"}});export{t as default};
//# sourceMappingURL=messages.js.map
